import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedTake3D,
  updateSelectedTakeProperty,
} from "../../app/slices/TrainingSlice";
import { InteractionProperty } from "../../models/InteractionProperty";
import InteractionPropertyView from "../interaction_properties_column/InteractionPropertyView";
import EditorColumn, {
  EditorColumnFieldGroup,
  EditorColumnHeader,
  EditorColumnSection,
} from "../editor_columns/EditorColumn";

export default function Take3DCameraPropertiesColumn() {
  const dispatch = useDispatch();
  const take = useSelector(selectSelectedTake3D);
  const { t } = useTranslation();

  const onChange = (interactionProperty: InteractionProperty) => {
    dispatch(updateSelectedTakeProperty(interactionProperty));
  };

  const storyProp = take?.properties?.find((p) => p.id === "isStory");
  const storyView = storyProp ? (
    <InteractionPropertyView
      interactionProperty={storyProp}
      onChange={onChange}
    />
  ) : (
    <></>
  );

  return (
    <EditorColumn
      testId="take3d-camera-properties-column"
      widthClassName="w-full min-w-0"
      borderSide="left"
      header={
        <EditorColumnHeader
          icon={<CameraAltOutlinedIcon fontSize="inherit" />}
          title={take?.mainCamera?.name ?? "Camera"}
          testId="take3d-camera-properties-header"
        />
      }
    >
      {take && (
        <EditorColumnSection
          title={t("camera")}
          icon={<CameraAltOutlinedIcon fontSize="inherit" />}
          defaultExpanded
          testId="take3d-camera-properties-section"
        >
          <EditorColumnFieldGroup>{storyView}</EditorColumnFieldGroup>
        </EditorColumnSection>
      )}
    </EditorColumn>
  );
}
